import { Ticket, Tag, UserStar } from 'lucide-react';

const SECTION_DEFS = [
  {
    id: 'ordem',
    title: 'Ordem de serviço',
    Icon: Ticket,
    keys: ['tipoOS', 'retorno', 'sla', 'status', 'equipamento', 'tecnicoInicial', 'osFutura'],
  },
  {
    id: 'local',
    title: 'Cliente e localização',
    Icon: UserStar,
    keys: ['cliente', 'cidade', 'bairro'],
  },
  {
    id: 'classificacao',
    title: 'Classificação',
    Icon: Tag,
    keys: ['defeitoDescricao', 'defeitoAlert', 'defeitoClassification', 'defeitoSeverity'],
  },
];

export function organizeFilterChipSections(filterOptions, defeitoSubOptions) {
  const clearOption = filterOptions.find((o) => o.isClearAction);
  const previsaoOption = filterOptions.find((o) => o.key === 'previsao');

  const optionMap = {};
  filterOptions.forEach((o) => {
    if (o.isClearAction || o.key === 'previsao' || o.key === 'defeitoSubmenu') return;
    optionMap[o.key] = { ...o, openSubmenu: false };
  });
  (defeitoSubOptions || []).forEach((o) => {
    optionMap[o.key] = { ...o, openSubmenu: false };
  });

  const sections = SECTION_DEFS.map(({ id, title, Icon, keys }) => ({
    id,
    title,
    Icon,
    chips: keys.map((key) => optionMap[key]).filter(Boolean),
  })).filter((section) => section.chips.length > 0);

  return {
    clearOption,
    topChips: previsaoOption ? [previsaoOption] : [],
    sections,
  };
}

export function sortByCountDesc(items, getCount = (item) => item.count ?? 0) {
  return [...items].sort((a, b) => getCount(b) - getCount(a));
}
